import { Col, Row } from "antd";
import React, { useState } from "react";
import styled from "styled-components";
import { useMutation } from "react-query";
import { useNavigate } from "react-router";
import Button from "../../../../components/atoms/Button";
import Input from "../../../../components/atoms/Input";
import { ReactComponent as FillCaution } from "../../../../assets/icons/FillNotice.svg";
import RequiredStar from "../../../../components/atoms/RequiredStar";
import Modal from "../../../../components/molecures/Modals/Modal";
import {
  cancelRepairShop,
  checkPhoneAuth,
  sendPhoneNumber,
} from "../../../../apis/ReRegister/apis";
import { HttpError } from "../../../../network/types";
import ExplainWrapper from "../../../../components/molecures/ExplainWrapper";
import {
  alertDelete,
  alertError,
  alertSuccess,
  validatePhone,
} from "../../../../shared/utils";
import sharedConstants from "../../../../shared/constants";
import useModals from "../../../../hooks/useModals";
import { PATH } from "../../../../routes/constants/path";

interface Props {
  id: number;
}
const CancelModal: React.FC<Props> = ({ id }) => {
  const { resetModal } = useModals();
  const nav = useNavigate();
  const sendPhoneMutation = useMutation(sendPhoneNumber, {
    onSuccess: (res) => {
      alertSuccess(sharedConstants.message.ALERT_MESSAGE.PHONE_SEND);
      setAuthTokenId(res.authTokenId);
    },
    onError: () => {},
  });
  const checkPhoneAuthMutation = useMutation(checkPhoneAuth, {
    onSuccess: (res) => {
      setTokenStatus("");
      setAuthPass(true);
      setRealAccessToken(res.accessToken);
    },
    onError: () => {
      setTokenStatus(sharedConstants.message.ALERT_MESSAGE.WRONG_AUTH);
    },
  });
  const cancelRepairShopMutation = useMutation(cancelRepairShop, {
    onSuccess: () => {
      resetModal();
      alertDelete("제휴 취소가 완료되었습니다.");
      nav(PATH.LOGIN);
    },
    onError: (error: HttpError) => {
      setAuthPass(false);
      alertError(error.message);
    },
  });
  const onSendPhone = () => {
    if (validatePhone(phone)) sendPhoneMutation.mutate({ key: phone });
    else setPhoneStatus(sharedConstants.message.ALERT_MESSAGE.WRONG_PHONE);
  };

  const onCheckPhoneAuth = () => {
    checkPhoneAuthMutation.mutate({
      key: phone,
      token: accessToken,
      authTokenId,
    });
  };
  const onOk = () => {
    if (id && realAccessToken && authTokenId)
      cancelRepairShopMutation.mutate({
        id,
        accessToken: realAccessToken,
        authTokenId,
      });
  };
  const [phone, setPhone] = useState<string>("");
  const [authTokenId, setAuthTokenId] = useState<string>("");
  const [accessToken, setAccessToken] = useState<string>("");
  const [phoneStatus, setPhoneStatus] = useState<string>("");
  const [tokenStatus, setTokenStatus] = useState<string>("");
  const [realAccessToken, setRealAccessToken] = useState<string>("");
  const [isAuthPass, setAuthPass] = useState<boolean>(false);
  return (
    <Modal
      onAdditional={resetModal}
      width={700}
      title="휴대폰 번호 변경"
      isOkDanger
      okText="신청 취소"
      isOkDisabled={!isAuthPass}
      onOk={onOk}
    >
      <StyledContainer>
        <StyledNotice>
          <Row gutter={[12, 0]} align="middle">
            <Col>
              <FillCaution />
            </Col>
            <Col style={{ color: "#E60000" }} flex="1 0 0">
              제휴 신청을 취소하겠어요?
              <br />
              취소 시 자동 탈퇴 처리와 함께 입력하신 데이터가 모두 삭제되며,
              <br />
              재신청을 원하시는 경우 재가입하여 새로 신청하셔야 합니다.
            </Col>
          </Row>
        </StyledNotice>

        <Row style={{ marginTop: "24px" }} gutter={[0, 24]}>
          <Col span={24}>
            <Row gutter={[8, 0]} wrap={false}>
              <StyledCol flex="0 0 165px">
                휴대폰 번호<RequiredStar>*</RequiredStar>
              </StyledCol>
              <Col flex="1 0 0">
                <ExplainWrapper
                  status={
                    phoneStatus
                      ? { status: "error", explain: phoneStatus }
                      : undefined
                  }
                >
                  <Input
                    status={phoneStatus ? "error" : undefined}
                    name="phone"
                    value={phone}
                    onPressEnter={onSendPhone}
                    onChange={(e) => {
                      setPhoneStatus("");
                      setTokenStatus("");
                      setPhone(e.target.value);
                      setAuthTokenId("");
                      setAuthPass(false);
                    }}
                    onBlur={(e) => {
                      e.target.value.replaceAll("-", "");
                    }}
                    placeholder="‘-’ 없이 숫자만 입력해주세요"
                  />
                </ExplainWrapper>
              </Col>
              <Col>
                <Button size="middle" ghost onClick={onSendPhone}>
                  {!authTokenId ? "인증번호 전송" : "재전송"}
                </Button>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[8, 0]}>
              <StyledCol span={24} flex="0 0 165px">
                인증번호<RequiredStar>*</RequiredStar>
              </StyledCol>
              <Col flex="1 0 0">
                <ExplainWrapper
                  status={
                    isAuthPass
                      ? {
                          status: "success",
                          explain: "휴대폰 인증이 완료되었습니다.",
                        }
                      : tokenStatus
                      ? { status: "error", explain: tokenStatus }
                      : undefined
                  }
                >
                  <Input
                    status={tokenStatus ? "error" : undefined}
                    disabled={isAuthPass}
                    maxLength={4}
                    onPressEnter={onCheckPhoneAuth}
                    value={accessToken}
                    onChange={(e) => {
                      setTokenStatus("");
                      setAccessToken(e.target.value);
                    }}
                    placeholder="인증번호를 입력해주세요"
                  />
                </ExplainWrapper>
              </Col>
              <Col>
                <Button
                  size="middle"
                  ghost
                  onClick={onCheckPhoneAuth}
                  disabled={isAuthPass || !authTokenId}
                >
                  인증번호 확인
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledContainer>
    </Modal>
  );
};
export default CancelModal;
const StyledContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
`;
const StyledNotice = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px;

  background: #fff2f3;
  border-radius: 4px;
`;
const StyledCol = styled(Col)`
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 32px;
  display: flex;
  flex-wrap: nowrap;
`;
